function userPermission (context, userData, actionName = null) {
  if (userData.user_role == "USERROLE11111") {
    return true
  }

  // Check if User has permission to perform this action
  if (userData.user_permission && JSON.stringify(userData.user_permission).includes(actionName)) {
    return true
  }

  // This is the correct way of access control, in future we will be falling back to this.
  let apiGroup = "N/A"
  if (actionName) {
    apiGroup = actionName.split("_")
    if (apiGroup.length > 1) {
      apiGroup = apiGroup.slice(0, -1).join("_") + "*"
    }
    else {
      apiGroup = apiGroup[0] + "*"
    }
  }

  if (userData.user_permission && JSON.stringify(userData.user_permission).includes(apiGroup)) {
    return true
  }

  // This is a wrong way of access control cause the function is generic and we do not have org_id in every component
  let cvOrgId = context.cvOrgId ? context.cvOrgId : null
  if (cvOrgId && Object.keys(userData.roles).length > 0 && (userData.roles[cvOrgId].udr_name.toLowerCase() === "admin" || userData.roles[cvOrgId].udr_name.toLowerCase() === "owner")) {
    return true
  }

  console.error(actionName, apiGroup, cvOrgId, userData.roles[cvOrgId]?.udr_name, JSON.stringify(userData.user_permission).includes(actionName), `Unauthorized access on ${actionName}. Allowed User Actions are` + JSON.stringify(userData.user_permission))
  return false
}

export default userPermission
